import { TZDate } from "@date-fns/tz";
import { parseISO, format, isValid } from "date-fns";
import { toZonedTime } from "date-fns-tz";

export function formatDate(
  dateUTC: Date,
  params: Intl.DateTimeFormatOptions,
): string {
  const date = convertToTZDate(dateUTC);
  return date.toLocaleString("nb-NO", params);
}

export const convertToTZDate = (date: Date): Date => {
  const timezone = "Europe/Oslo";
  return new TZDate(date, timezone);
};

const hasSkipBookDeadlineTimeOfDay = (deadline: string): boolean => {
  const zoned = toZonedTime(parseISO(deadline), "Europe/Oslo");

  return !(
    zoned.getHours() === 23 &&
    zoned.getMinutes() === 59 &&
    zoned.getSeconds() === 59
  );
};

/**
 * Formats a cancellation deadline, including the time of day when the deadline
 * expires at a specific time rather than at the end of the day.
 */
export function formatSkipBookDeadline(
  deadline: string,
  dateOptions: Intl.DateTimeFormatOptions = {
    day: "2-digit",
    month: "long",
    year: "numeric",
  },
): string {
  const date = new Date(deadline);
  const formattedDate = formatDate(date, dateOptions);

  if (!hasSkipBookDeadlineTimeOfDay(deadline)) {
    return formattedDate;
  }

  const formattedTime = formatDate(date, {
    hour: "2-digit",
    minute: "2-digit",
  });

  return `${formattedDate} kl. ${formattedTime}`;
}

export function formatPublicationDate(publicationDate: string): string | null {
  // Supports both "2026-03-02" and "2026-03-02T00:00:00.000Z"
  const date = parseISO(publicationDate);
  if (!isValid(date)) return null;

  // Format to “02.03.”
  const osloDate = convertToTZDate(date);
  return format(osloDate, "dd.MM.");
}
